// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 10357); hand-edits allowed (see docs/architecture.md)

/** `this.WEAPON_ICONS` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_WEAPON_ICONS(): any {
  return {
    "bazooka": "267157036",
    "unfail_bazooka": "267157037",
    "fire_bazooka": "267157038",
    "poison_bazooka": "267157039",
    "ap_bazooka": "267157040",
    "howitzer": "268707186",
    "ap_bazooka2": "270703942",
    "rj46": "270703958",
    "grenade": "267157041",
    "unfail_grenade": "267157042",
    "plasma_grenade": "267157043",
    "pulse_grenade": "267157044",
    "holy_hand_grenade": "267157045",
    "dl19": "270703960",
    "cluster_bomb": "267157046",
    "unfail_cluster_bomb": "267157047",
    "putty_grenade": "269335960",
    "molotov": "267157048",
    "mortar": "267157049",
    "upg_mortar": "267157050",
    "banana_bomb": "267157051",
    "unfail_banana_bomb": "267157052",
    "super_banana_bomb": "267157053",
    "nuclear_bomb": "267157054",
    "multi_bazooka": "267157055",
    "mega_banana_bomb": "270703935",
    "pistol": "267157056",
    "uzi": "267157057",
    "unfail_uzi": "267157058",
    "hunting_rifle": "267157059",
    "sniper_rifle": "267157060",
    "rad_rifle": "269296388",
    "peacemaker": "268699521",
    "shotgun": "267157061",
    "minigun": "267157062",
    "unfail_minigun": "267157063",
    "air_minigun": "267157064",
    "bozar": "267157065",
    "avenger": "269827766",
    "air_strike": "267157066",
    "napalm_strike": "267157067",
    "mine_strike": "267157068",
    "banana_strike": "267157069",
    "holy_strike": "267157070",
    "mine": "267157071",
    "unfail_mine": "267157072",
    "fire_mine": "267157073",
    "plasma_mine": "267157074",
    "pulse_mine": "267157075",
    "nuclear_mine": "269296389",
    "dynamite": "267157076",
    "unfail_dynamite": "267157077",
    "dynamite_bunch": "269116675",
    "old_woman": "267157080",
    "unfail_old_woman": "267157081",
    "sheep": "267157078",
    "unfail_sheep": "267157079",
    "fire_sheep": "267157082",
    "poison_sheep": "267157083",
    "mine_sheep": "269296390",
    "mine_sheep2": "269296391",
    "prod": "267157084",
    "firepunch": "267157112",
    "fireball": "267157113",
    "kamikaze": "267356278",
    "baseball_bat": "267157114",
    "shocker": "267157115",
    "battle_axe": "267157116",
    "power_axe": "267157117",
    "power_bat": "267157118",
    "skip_go": "267157119",
    "laser_sight": "267157120",
    "low_gravity": "267157121",
    "fast_walk": "267157122",
    "ultra_scaner": "268401725",
    "gravity_grenade": "270704152",
    "invisibility": "271641568",
    "blow_torch": "267157123",
    "pneumatic_drill": "267157124",
    "parachute": "267157125",
    "girder": "267157126",
    "girder_pack": "267157127",
    "jet_pack": "267157128",
    "teleport": "267157129",
    "upg_teleport": "267157130",
    "upg_jet_pack": "267157131",
    "ag_pack": "267157132",
    "add_time": "267157133",
    "choose_worm": "267157134",
    "upg_teleport2": "267304796",
    "emg_teleport": "269335962",
    "medikit": "269335961",
    "super_medikit": "269827767",
    "laser_pistol": "267157135",
    "laser_rifle": "267157136",
    "unfail_laser_rifle": "267157137",
    "laser_minigun": "267157138",
    "pulse_pistol": "267157147",
    "plasma_pistol": "267157139",
    "plasma_rifle": "267157140",
    "unfail_plasma_rifle": "267157141",
    "plasma_minigun": "267157142",
    "luiston": "267157148",
    "gauss_pistol": "267157143",
    "gauss_rifle": "267157144",
    "unfail_gauss_rifle": "267157145",
    "gauss_minigun": "267157146",
    "de_lameter": "267157149",
    "turbo_rifle": "269827763",
    "orbit_strike": "267157150",
    "ultra_rifle": "267157151",
    "vindicator": "269827761"
  };
}
